import { TextField } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import ToggleButtons from "./ToggleButtons";
import { useState } from "react";

const _spacing = "10px";

const BqForm = props => {
  const [toggleOption, setToggleOption] = useState(0);

  const handleChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    // if (name === "nameWithDob") {
    //   props.setQueryState(prevState => {
    //     return { ...prevState, [name]: value, name: null, soundex: null };
    //   });
    // } else {
    props.setQueryState(prevState => {
      return {
        ...prevState,
        [name]: value,
      };
    });
    // }
  };

  const handleDateChange = (date, str) => {
    props.setQueryState(prevState => {
      return { ...prevState, dob: str };
    });
  };

  const Registration = () => {
    return (
      <TextField
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        margin="dense"
        id="boat-registration-id"
        label="Boat Registration Number"
        value={props?.queryState?.boatRegistration?.toUpperCase() || ""}
        onChange={handleChange}
        name="boatRegistration"
        helperText="Up to 10 alphanumeric characters"
        style={{ width: "45%" }}
      />
    );
  };

  const BoatHullNumber = () => {
    return (
      <TextField
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        margin="dense"
        id="bhn-id"
        label="Boat Hull Number"
        value={props?.queryState?.boatHullNumber?.toUpperCase() || ""}
        onChange={handleChange}
        name="boatHullNumber"
        helperText="Up to 20 alphanumeric characters"
        style={{ width: "45%" }}
      />
    );
  };

  const NameDob = () => {
    return (
      <>
        <TextField
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          margin="dense"
          id="name-with-dob-id"
          label="Name"
          value={props?.queryState?.name || ""}
          onChange={handleChange}
          name="name"
          helperText="Last name, First name Middle Initial"
          style={{ width: "45%" }}
        />
        <KeyboardDatePicker
          data-testid="dob"
          inputProps={{ "data-testid": "dob-input" }}
          autoOk
          variant="inline"
          inputVariant="outlined"
          label="Date of birth"
          value={props?.queryState?.dob || null}
          onChange={(date, str) => handleDateChange(date, str)}
          format="YYYYMMDD"
          helperText="Date format: YYYYMMDD"
          disableFuture={true}
          style={{ width: "45%" }}
        />
      </>
    );
  };

  const CoastGuardNumber = () => {
    return (
      <TextField
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        margin="dense"
        id="cgn-id"
        label="Coast Guard Number"
        value={props?.queryState?.coastGuardNumber || ""}
        onChange={handleChange}
        name="coastGuardNumber"
        helperText="Up to 10 alphanumeric characters"
        style={{ width: "45%" }}
      />
    );
  };

  const formOptions = [Registration, BoatHullNumber, NameDob, CoastGuardNumber];

  return (
    <div
      data-testid="bq-form"
      id="bottom-half"
      style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}
    >
      {props.children}
      <ToggleButtons
        buttons={[
          { name: "Registration" },
          { name: "Boat Hull Number" },
          { name: "Name/DOB" },
          { name: "Coast Guard Number" },
        ]}
        callback={setToggleOption}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        {formOptions[toggleOption] && formOptions[toggleOption]()}
      </div>
    </div>
  );
};

export default BqForm;
